<!-- 项目角色 -->
<template>
  <div class="app-container">
    <el-card class="box-card">
      <!-- 搜索-->
      <dynamic-search :data="tableFilterList(tableHead)" @search="dataTableSearch">
        <template v-slot:next>
          <el-button icon="el-icon-plus" @click="add()">新增</el-button>
        </template>
      </dynamic-search>
      <drag-dialog
        append-to-body
        :show.sync="dialogVisible"
        title="项目角色"
        :enableDrag="true"
        width="500px"
        @close="cancel"
      >
        <dynamic-form
          :formConfig="formConfig"
          labelWidth="120px"
          v-model="form"
          @submit="submit"
          @cancelForm="cancel"
          :disabled="openLook"
          ref="pageForm"
        ></dynamic-form>
      </drag-dialog>
      <edit-data-table
        :head="tableHead"
        :data.sync="list"
        :edit-rules="validRules"
        :config="{trigger: 'click', mode: 'cell'}"
        :total="total"
        :offset="offset"
        :page="page"
        :loading="loading"
        stripe
        @handlePageChange="dataTablePageChange"
        @handleSizeChange="dataTableSizeChange"
      >
        <template #toolbar="scope">
          <el-button
            type="text"
            size="mini"
            icon="el-icon-edit"
            @click="edit(scope.row)"
          ></el-button>
          <el-popover :ref="scope.row.id" placement="top" width="180">
            <p>确定删除本条数据吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="$refs[scope.row.id].doClose()">取消</el-button>
              <el-button :loading="delLoading" type="primary" size="mini" @click="del(scope.row)">确定</el-button>
            </div>
            <el-button
              type="text"
              size="mini"
              icon="el-icon-delete"
              slot="reference"
            ></el-button>
          </el-popover>
        </template>
      </edit-data-table>
    </el-card>
  </div>
</template>

<script>
import "@/components/EditDataTable";
import DynamicSearch from "@/components/DynamicSearch";
import DataTableMixin from "@/mixins/DataTableMixin";
import "@/components/dynamic-form";
import DragDialog from "@/components/DragDialog";
import {
  addProjectRoles,
  editProjectRoles,
  deleteProjectRoles
} from "@/api/project-roles";
export default {
  name: "Demo",
  directives: {},
  filters: {},
  mixins: [DataTableMixin],
  props: {},
  components: {
    DynamicSearch,
    DragDialog
  },
  data() {
    return {
      delLoading: false,
      openLook: false,
      dialogVisible: false,
      form: {},
      formConfig: {
        formItemList: [
          {
            type: "input",
            key: "code",
            maxlength: "50",
            label: "项目角色代码",
            value: "",
            rules: [
              {
                required: true,
                message: "项目角色代码不能为空",
                trigger: "blur"
              },
              {
                pattern: "^[^\u4e00-\u9fa5]{0,}$",
                message: "项目角色代码不能含有中文",
                trigger: "blur"
              },
            ]
          },
          {
            type: "input",
            key: "name",
            maxlength: "100",
            label: "项目角色名称",
            value: "",
            rules: [
              {
                required: true,
                message: "项目角色名称不能为空",
                trigger: "blur"
              }
            ]
          },
          {
            label: "权益方",
            key: "stakeholder",
            type: "select",
            options: [
              { value: "甲方", label: "甲方" },
              { value: "乙方", label: "乙方" },
              { value: "第三方", label: "第三方" }
            ],
            rules: {
              required: true,
              message: "不能为空",
              trigger: "change"
            }
          },
          {
            type: "textarea",
            maxlength: "200",
            key: "remark",
            label: "备注",
            value: "",
            placeholder: "请输入备注"
          }
        ]
      },
      tableHead: [
        {
          prop: "code",
          label: "项目角色代码",
          editRender: { name: "ElInput" }
        },
        {
          prop: "name",
          label: "项目角色名称",
          editRender: { type: "number", name: "ElInputNumber" },
          query: {
            type: "input"
          }
        },
        {
          prop: "stakeholder",
          label: "权益方",
          editRender: { name: "ElSelect" },
          // query: {
          //   type: "select",
          //   options: [
          //     { value: "0", label: "甲方" },
          //     { value: "1", label: "乙方" },
          //     { value: "2", label: "第三方" }
          //   ]
          // }
        },
        {
          prop: "remark",
          label: "备注",
          editRender: { name: "ElInput" }
        }
      ],
      validRules: {
        code: [{ required: true, message: "请输入键值", trigger: "blur" }],
        name: [
          { required: true, message: "请输入项目角色名称", trigger: "blur" }
        ],
        stakeholder: [
          { required: true, message: "所属权益方不能为空", trigger: "change" }
        ]
      }
    };
  },
  computed: {},
  watch: {},
  created() {
    // 列表数据初始化
    this.$nextTick(() => {
      // console.log(1);
      this.dataTableInit();
    });
  },
  methods: {
    editActiveEvent(row, column) {
      console.log(row, column);
    },
    // 表格数据接口参数设置
    dataTableBeforeInit() {
      this._url = `/bsProjectRoles`;
      const params = {
        size: this.offset,
        page: this.page
      };
      this._params = Object.assign(params, this._query);
      return true;
    },
    // 取消关闭弹框
    cancel() {
      this.dialogVisible = false;
    },
    // 删除
    del(row) {
      // console.log(row);
      this.delLoading = true;
      deleteProjectRoles(row.id)
        .then(() => {
         this.$notify({ title: "删除成功！", type: "success", duration: 2500 });
          this.dataTableInit();
          this.delLoading = false;
        })
        .catch(() => {
          this.delLoading = false;
        });
    },
    // 打开添加弹框
    add() {
      this.form = {};
      this.dialogVisible = true;
    },
    // 修改
    edit(row) {
      this.form = row;
      this.dialogVisible = true;
    },
    // 提交 （添加/修改）
    submit() {
      if (this.form.id) {
        editProjectRoles(this.form).then(res => {
          this.$notify({ title: "操作成功！", type: "success", duration: 2500 });
          this.dataTableInit();
          this.cancel();
        });
      } else {
        addProjectRoles(this.form).then(res => {
           this.$notify({ title: "操作成功！", type: "success", duration: 2500 });
          this.dataTableInit();
          this.cancel();
        });
      }
    }
  }
};
</script>

<style scoped>
.btn {
  border: none;
  padding: 0;
}
</style>
